// extracted by mini-css-extract-plugin
module.exports = {"circle":"dl1ac","avatarFallback":"_2GWK5","large":"_1D8TY","small":"_16Jld"};